import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AbstractValueAccessor, MakeProvider} from '../web-components/abstract-value-accessor';
import {AbstractControl, ValidationErrors} from "@angular/forms";

export const StarsRequired = (control: AbstractControl): ValidationErrors | null => {
  return control.value > 0 ? null : {required: true};
};


@Component({
    selector: 'app-five-star-rating-radio-buttons',
    templateUrl: './five-star-rating-radio-buttons.component.html',
    styleUrls: ['./five-star-rating-radio-buttons.component.scss'],
    providers: [MakeProvider(FiveStarRatingRadioButtonsComponent)],
    standalone: false
})
export class FiveStarRatingRadioButtonsComponent extends AbstractValueAccessor {
  @Input() label = '';
  @Input() lowScoreLabel = '';
  @Input() highScoreLabel = '';
  @Input() invalid = false;
  @Output() valueChanged = new EventEmitter();


  radioSelected($event: any) {
    this.onChange($event.value);
    this.valueChanged.emit($event.value);
  }
}
